import { Record } from 'immutable'
import { CityProfileSpecialFileType } from './enums'

export interface ICityProfileSpecialFile {
  readonly fileId: string
  readonly type: CityProfileSpecialFileType
}

const CityProfileSpecialFileRecord = Record({
  fileId: '',
  type: CityProfileSpecialFileType.RetailNodeMap,
})

export class CityProfileSpecialFile extends CityProfileSpecialFileRecord
  implements ICityProfileSpecialFile {
  public static fromJS(initialState?: Partial<ICityProfileSpecialFile>) {
    if (!initialState) {
      return new CityProfileSpecialFile()
    }

    const { ...rest } = initialState

    return new CityProfileSpecialFile({
      ...rest,
    })
  }

  public readonly fileId: string
  public readonly type: CityProfileSpecialFileType

  constructor(initialState?: Partial<CityProfileSpecialFile>) {
    initialState ? super(initialState) : super()
  }
}
